
export default [
  {
    path: '/intention/login',
    name: 'login',
    component: () => import('./login/index.vue'),
    meta: {
      name: '商户登录',
      nologin: true,
    }
  },
  {
    path: '/intention/menu',
    name: 'intention-menu',
    component: () => import('./login/menu.vue'),
    meta: {
      name: '模拟菜单',
      nologin: true,
    }
  },
  {
    path: '/intention/subject',
    name: 'intention-subject',
    component: () => import('./login/subject-picker.vue'),
    meta: {
      name: '选择主体',
      nologin: true,
    }
  },
  {
    path: '/intention/shop',
    name: 'intention-shop',
    component: () => import('./login/shop-picker.vue'),
    meta: {
      name: '选择店铺',
    }
  },
  {
    path: '/intention/city-pick',
    name: 'cityPick',
    component: () => import('./city-pick/index.vue'),
    meta: {
      name: '选择城市',
    }
  },
  {
    path: '/intention/entrance',
    name: 'intention-entrance',
    component: () => import('./entrance/entrance-menu.vue'),
    meta: {
      name: '入口菜单',
    }
  },
];
